import './style.css';
import { renderLogin } from './auth/login';
import { bootstrap } from './app';
import { initTheme } from './ui/theme';
import { initLang } from './ui/lang';
// Statically imported, not lazily: the panel ships as ONE bundle (the server serves
// only /panel-bundle.*), so a split chunk would 404 on the guest page.
import { renderGuestShare } from './share/guest-view';
initTheme();
initLang();
/** `/s/<token>` — the guest share page. Same bundle, but it never boots the panel. */
const SHARE_PATH = /^\/s\/([A-Za-z0-9_-]{16,128})$/;
async function init() {
    // Checked before /api/auth/me: a guest has no session, and an operator opening a
    // share link should get the shared device, not their own panel.
    const share = SHARE_PATH.exec(location.pathname);
    if (share) {
        await renderGuestShare(share[1]);
        return;
    }
    const res = await fetch('/api/auth/me');
    if (res.ok) {
        const user = await res.json();
        bootstrap(user);
    }
    else {
        renderLogin((user) => bootstrap(user));
    }
}
init();
